
<div class="owner-dashboard">
  <h1>Tableau de bord Proprio</h1>
  <mat-accordion multi>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Mon Parc </h5>
          <button class="simple-button" mat-button routerLink="/owner/park"><mat-icon>open_in_new</mat-icon>Gérer</button>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/owner/park']">Voir mes voitures</a></h6>
          <h6><a [routerLink]="['/owner/post-new-car']">Poster une voiture</a></h6>
        </div>
      }

    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Ventes</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/owner/buy']">Ventes en cours </a></h6>
          <h6><a [routerLink]="['/owner/buy']">Ventes conclues</a></h6>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Locations</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/owner/rent']">Locations en cours</a></h6>
          <h6><a [routerLink]="['/owner/rent']">Locations conclues</a></h6>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Communications</h5>
          <button class="simple-button" mat-button routerLink="/provider/public">
            <mat-icon>open_in_new</mat-icon>Gérer
          </button>

        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/owner/appointments']">Mes rendez-vous </a></h6>
          <h6><a [routerLink]="['/owner/conversations']">Mes conversations</a></h6>
          <h6><a [routerLink]="['/owner/notifications']">Notifications</a></h6>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Mon Profil</h5>
          <button class="simple-button" mat-button routerLink="/provider/public">
            <mat-icon>open_in_new</mat-icon>Gérer
          </button>

        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/owner/my-providers']">Mes fournisseurs </a></h6>
          <h6><a [routerLink]="['/owner/contracts']">Mes contrats</a></h6>
          <h6><a [routerLink]="['/owner/account']">Mon compte</a></h6>
          <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: dealerData.username}">Voir mon profil public </a></h6>
        </div>
      }
    </mat-expansion-panel>

  </mat-accordion>

</div>






